import { Aula } from '../../domain/entities/Aula';
import { AulaRepository } from '../../domain/repositories/AulaRepository';

export class GetAulasUseCase {
  constructor(private aulaRepository: AulaRepository) {}

  async execute(): Promise<Aula[]> {
    return await this.aulaRepository.findAll();
  }
} 